// 环境开关配置文件 （发包时配置)

export default {
  commissionDisplay: false, // 佣金展示开关 默认开
}
